import _regeneratorRuntime from "/app/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _objectSpread from "/app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _asyncToGenerator from "/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.link.js";
import { request } from "@/js/http/http_request";
import { orderStatus } from "@/js/lists.ts";
import { getIdUserFromToken, isUserBuyerGroup, isAdminNotConsultant, isHolding, isConsultantNotHolding } from "@/js/http/auth.js";
import userOrderSummary from "@/components/order/UserOrderSummary.vue";
import Error from "@/views/error/error.vue";
export default {
  name: "UserOrderView",
  props: ["loggedUserData"],
  data: function data() {
    return {
      id: null,
      order: null,
      idUser: null,
      idOrderUser: null,
      isDataLoading: true,
      error: {
        title: "order not found",
        link: "",
        linkTitle: "to orders",
        params: {
          tab: "orders"
        }
      }
    };
  },
  created: function created() {
    this.id_order = this.$route.params.id;
    if (isAdminNotConsultant(this.loggedUserData)) {
      return this.$router.push({
        name: "adminOrderSummary",
        params: {
          id: this.id_order
        }
      });
    } else if (isHolding(this.loggedUserData)) {
      return this.$router.push({
        name: "consultantOrderDetails",
        params: {
          id: this.id_order
        }
      });
    }
    this.idUser = getIdUserFromToken();
    this.error.link = isUserBuyerGroup(this.loggedUserData) ? "userOrderList" : "adminOrderList";
    this.getOrder();
  },
  components: {
    userOrderSummary: userOrderSummary,
    Error: Error
  },
  methods: {
    getOrder: function getOrder() {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var _this, response, isCart;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _this = _this2;
              _context.next = 3;
              return request("/v1/order/" + _this.id_order, "get", null, true, "api").catch(function (e) {
                _this.isDataLoading = false;
                throw e;
              });
            case 3:
              response = _context.sent;
              isCart = response.data.status === orderStatus.find(function (x) {
                return x.id == "CREATED";
              }).status;
              if (!isCart) {
                _this2.order = _objectSpread({}, response.data);
                _this2.idOrderUser = _this.order.id_user;
                _this2.isDataLoading = false;
                if (isConsultantNotHolding(_this.loggedUserData) && _this.idUser != _this.idOrderUser) {
                  _this.$router.push({
                    name: "consultantOrderDetails",
                    params: {
                      id: _this.id_order
                    }
                  });
                }
              } else {
                _this2.isDataLoading = false;
              }
            case 6:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    isUserBuyerGroup: isUserBuyerGroup,
    isConsultantNotHolding: isConsultantNotHolding
  }
};